import Vue from 'vue'
import VueRouter from 'vue-router'
import VueBus from 'vue-bus'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/icon/icon.css'

import './lib/util'
import routes from './routes'
import page from './chedai'

Vue.use(VueRouter)
Vue.use(VueBus)
Vue.use(ElementUI)

global.title = document.title

const el = '#page',
	mode = 'history',
	render = h => h(page),
	router = new VueRouter({ mode, routes }),
	methods = {
		pushRoute(key){
			//console.log(key)
			router.push(key)
		}
	},
	vm = new Vue({ 
		el, router, render, methods,
		created() {
			global.$bus = this.$bus
				.on('push-router',this.pushRoute)
		},
		beforeRouteEnter (to, from, next) {
			next((vm) => {
				console.log([to,vm.areaName])
			})
		},
		beforeDestroy() {
			this.$bus
				.off('push-router')
			global.$bus = undefined
		}
	})


// WEBPACK FOOTER //
// ./src/main.js